module.exports = __webpack_public_path__ + "img/neck-mesomorph-female.be1634b3.svg";